import { render } from "./LongSingleParagraph.vue?vue&type=template&id=d653d774"
import script from "./LongSingleParagraph.vue?vue&type=script&lang=js"
export * from "./LongSingleParagraph.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__